
import TimeCollection from '@/components/TimeCollection.vue';
import store from '@/store';
import Vue from 'vue'
import { CreatePollForSavedContactInput, EmailSendInput, UserSavedContactDetailMatchDirectionEnum, MatchRequest, Unit, SendMarkdownEmailInput, UpdateAvailabilityTimeInput, UserDto, UserSavedContactDetail, UserSavedContactRecommendedAction, UnitDto } from '@chainsight/networker-backend-axios-sdk';
import { format, startOfWeek, addWeeks, setHours, setMinutes, setSeconds, addDays, isAfter } from 'date-fns';
import { zonedTimeToUtc, formatInTimeZone } from 'date-fns-tz';
import { Editor } from '@toast-ui/vue-editor';
import i18n from '@/plugins/i18n'
import { translateMatches } from '@/utils/translator'

export default Vue.extend({
	name: 'BusinessMatchSavedContacts',
	components: {
		editor: Editor,
		TimeCollection
	},
	data() {
		return {
			UserSavedContactDetailMatchDirectionEnum,
			overlay: false,
			isSearchLoading: false,
			progressValue: 0,
			progressStatusText: '',
			progressInterval: null as any,
			emailDialog: false,
			deleteDialog: false,
			emailSuccessDialog: false,
			sendEmailDialog: false,
			sendEmailSubject: '',
			sendEmailContent: '',
			sendEmailSharingUrl: '',
			sendEmailFixedContent: '',
			sendEmailLoading: false,
			// Snackbar
			snackbar: false,
			snackbarText: '',
			snackbarColor: '#1976D1',
			snackbarLinkText: '',
			snackbarLinkRoute: '',
			snackbarTextAfter: '',
			isRequiredImageError: false,
			isFilterBarOpen: false,
			detailDrawer: false,
			mobileDetailDrawer: false,
			timeCollectionDialog: false,
			isSupplyDescExpanded: false,
			isDemandDescExpanded: false,
			emailContentMarkdownForEdit: '',
			timeStrings: [] as string[],
			utcTimeStrings: [] as string[],
			demandDescriptions: [] as string[],
			supplyDescriptions: [] as string[],
			matchRequest: {} as MatchRequest,
			userSavedContactDetail: {
				unit: {
					id: 0,
					community: [] as {
						url: string,
						platform: string
					}[]
				}
			} as UserSavedContactDetail,
			community: [] as {
				url: string,
				platform: string
			}[],
			booths: [] as { 
				url: string
				name: string 
			}[],
			contactList: [] as UnitDto[],
			contactListRefactor: [] as {
				firstName: string,
				lastName: string,
				title: string[],
				email: string,
				mobilePhone: string,
				community: {
					url: string | null,
					platform: string | null
				}[]
			}[],
			userDto: {} as UserDto,
			savedContacts: {
				userSavedContactDetails: [] as UserSavedContactDetail[]
			},
			recommendedAction: {} as UserSavedContactRecommendedAction,
			availabilitySettings: {
				timezone: "",
				availableDays: {
					monday: false,
					tuesday: false,
					wednesday: false,
					thursday: false,
					friday: false,
					saturday: false,
					sunday: false,
				},
				availableHours: {
					monday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					tuesday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					wednesday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					thursday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					friday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					saturday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					sunday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
				},
				meetingDuration: 60,
				repeatWeeks: 0,
				lastUpdated: 0
			},
			editorOptions: {
				hideModeSwitch: true,
				toolbarItems: [
					['heading', 'bold', 'italic', 'strike'],
					['hr', 'quote'],
					['ul', 'ol', 'task', 'indent', 'outdent'],
					['table', 'link'],
					['code', 'codeblock'],
					['scrollSync'],
				]
			},
			currentPage: 0,
			pageSize: 10,
			isLoadingMore: false,
			hasMorePages: true,
			hasSearched: false
		};
	},
	computed: {
		trackDto(){
			return store.state.track.trackDto
		},
		user() {
			return store.state.user;
		}
	},
	methods: {
		capitalizeFirst(text: string): string {
			if (!text) return ''
			return text.charAt(0).toUpperCase() + text.slice(1)
		},
		normalizedWebsite(url: string) {
			if (!url) return ''; // 沒有網址就回傳空字串
			if (/^https?:\/\//i.test(url)) {
				return url;
			}
			return 'https://' + url;
		},
		async getMe(){
			try {
				const resp = await this.api$.authApi.getMe();
				this.userDto = resp.data.data as UserDto;
			} catch (e) {
				console.error(e);
			}
		},
		async handleSaveFromChild(payload) {
			this.overlay = true
			this.availabilitySettings = payload;

			const updateAvailabilityTimeInput : UpdateAvailabilityTimeInput = {
				availabilityTime: this.availabilitySettings
			}

			let updateAvailabilityTimeResp
			try {
				updateAvailabilityTimeResp = await this.api$.profileApi.updateAvailabilityTime(this.user.userDto?.id as string, updateAvailabilityTimeInput)
				this.userDto = updateAvailabilityTimeResp.data.data
			} catch (error) {
				console.error(error);
			}

			// 處理時間
			const result: string[] = []
			const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
			const now = new Date()
			const thisWeekStart = startOfWeek(now, { weekStartsOn: 0 })
			// const repeatWeeks = this.availabilitySettings.repeatWeeks ?? 1;

			// 清空之前的資料，避免重複
			this.timeStrings = [];
			this.utcTimeStrings = [];

			for (let weekOffset = 0; weekOffset < this.availabilitySettings.repeatWeeks; weekOffset++) {
				for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
					const dayName = daysOfWeek[dayIndex]
					if (!this.availabilitySettings.availableDays[dayName]) continue;
					const hoursMap = this.availabilitySettings.availableHours[dayName]
					if (!hoursMap) continue

					for (let hour = 0; hour < 24; hour++) {
						if (!hoursMap[hour]) continue

						const date = setSeconds(
						setMinutes(setHours(addDays(addWeeks(thisWeekStart, weekOffset), dayIndex), hour),0),0)

						// 只取比現在晚的時間
						if (isAfter(date, now)) {
							result.push(format(date, 'yyyy-MM-dd HH:mm'))
						}
					}
				}
			}

			this.timeStrings = result;

			this.timeStrings.map(timeStr => {
				const date = zonedTimeToUtc(timeStr, this.availabilitySettings.timezone);
				this.utcTimeStrings.push(formatInTimeZone(date, "UTC", "yyyy-MM-dd HH:mm"));
			});

			this.timeCollectionDialog = false;
			this.emailDialog = false;

			const createPollForSavedContactInput : CreatePollForSavedContactInput = {
				userEmail: this.user.userDto?.email,
				to: this.userSavedContactDetail.unit?.email,
				userSavedContactId: this.userSavedContactDetail.id,
				timeStrings: this.utcTimeStrings
			}

			let recommendedAction
			try{
				recommendedAction = await this.api$.businessMatchApi.createPollForSavedContact(this.user.userDto?.id as string, createPollForSavedContactInput)
				this.recommendedAction = recommendedAction.data.data

				const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
				if(editorInstance){
					if(this.trackDto?.id == '7'){
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
						this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
					}
					editorInstance.invoke('setMarkdown', this.recommendedAction.text as string);
				}else{
					if(this.trackDto?.id == '7'){
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
						this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
					}
					this.emailContentMarkdownForEdit = this.recommendedAction.text as string
				}
			} catch (error) {
				console.error(error);
			}
			
			this.emailDialog = true;
			this.overlay = false
		},
		handleEditorChange() {
			const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
			this.emailContentMarkdownForEdit = editorInstance.invoke('getMarkdown');
		},
		onImageError(item : UserSavedContactDetail) {
			if (item.unit && item.unit.entityName) {
				const firstLetter = item.unit.entityName.substring(0, 1).toUpperCase();
				item.unit.avatarUrl = require(`@/assets/business-match/alphabet/alphabet=${firstLetter}.png`);
			} else if(item.unit) {
				item.unit.avatarUrl = require('@/assets/business-match/alphabet/alphabet=Other.png');
			}
		},
		async getUserSavedContacts(isLoadMore = false){
			if (isLoadMore && !this.hasMorePages) return;
			
			if (isLoadMore) {
				this.isLoadingMore = true;
				this.currentPage++;
			} else {
				this.overlay = true;
				this.currentPage = 0;
				this.hasMorePages = true;
			}
			
			let getUserSavedContactsResp
			try {
				getUserSavedContactsResp = await this.api$.savedContactApi.getUserSavedContactsPaginated(
					this.user.userDto?.id as string, 
					this.trackDto?.id? this.trackDto.id : '0',
					this.currentPage,
					this.pageSize
				)
				
				const newData = getUserSavedContactsResp.data.data;
				console.log(newData)
				
				// 處理 tags
				newData.content?.forEach(saveContactDetail => {
					if (saveContactDetail.unit?.tags) {
						const parsed: any = JSON.parse(JSON.stringify(saveContactDetail.unit.tags));
						const chapterValue = parsed.chapter;
						const regionValue = parsed.region;
						const typeValue = parsed.type;

						saveContactDetail.unit.tags = JSON.parse(
							JSON.stringify({
								...(chapterValue != null && { chapter: chapterValue }),
								...(regionValue != null && { region: regionValue }),
								...(typeValue != null && { type: typeValue })
							})
						);
					}
				});
				
				// 翻譯處理
				if (i18n.locale === 'zh') {
					await translateMatches(newData.content || [], 'zh-Hant')
				} else if (i18n.locale === 'en') {
					await translateMatches(newData.content || [], 'en-US')
				} else if (i18n.locale === 'ja') {
					await translateMatches(newData.content || [], 'ja')
				}
				
				if (isLoadMore) {
					// 追加新資料
					if (!this.savedContacts.userSavedContactDetails) {
						this.savedContacts.userSavedContactDetails = [];
					}
					const newContacts = newData.content || [];
					this.savedContacts.userSavedContactDetails = this.savedContacts.userSavedContactDetails.concat(newContacts);
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				} else {
					// 第一次載入或重新載入
					this.savedContacts = {
						userSavedContactDetails: newData.content || []
					};

					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				}
			} catch (error) {
				console.error('Error fetching get matches:', error);
			} finally {
				this.hasSearched = true;
				this.isLoadingMore = false;
				this.overlay = false;
			}
		},
		handleScroll(event: Event) {
			const element = event.target as HTMLElement;
			const scrollHeight = element.scrollHeight;
			const scrollTop = element.scrollTop;
			const clientHeight = element.clientHeight;
			
			// 當滾動到底部附近時載入更多
			if (scrollHeight - scrollTop <= clientHeight + 100) {
				this.loadMore();
			}
		},
		loadMore() {
			if (this.isLoadingMore || !this.hasMorePages) return;
			this.getUserSavedContacts(true);
		},
		async insertUserSavedContactDetail(match : UserSavedContactDetail){
			this.overlay = true
			this.detailDrawer = true
			this.mobileDetailDrawer = true
			this.userSavedContactDetail = match
			this.demandDescriptions = JSON.parse(JSON.stringify(this.userSavedContactDetail.unit?.demands || "[]")).map((d) => d.description ?? d.description_short ?? d.descriptionShort);
			this.supplyDescriptions = JSON.parse(JSON.stringify(this.userSavedContactDetail.unit?.supplies || "[]")).map((s) => s.description ?? s.description_short ?? s.descriptionShort);
			this.overlay = false
		},
		async getEmail(userSavedContact){
			this.overlay = true
			let getUserContactsRecommendedActionsResp
			try{
				getUserContactsRecommendedActionsResp = await this.api$.savedContactApi.getUserContactsRecommendedActions(this.user.userDto?.id as string, userSavedContact, localStorage.getItem('locale') ?? 'en', this.trackDto?.id? this.trackDto.id : '0')
				this.recommendedAction = getUserContactsRecommendedActionsResp.data.data

				if(this.userDto.availabilityTime){
					await this.handleSaveFromChild(this.userDto.availabilityTime)
				} else{
					const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
					if(editorInstance){
						if(this.trackDto?.id == '7'){
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
							this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
						}
						editorInstance.invoke('setMarkdown', this.recommendedAction.text as string);
					}else{
						if(this.trackDto?.id == '7'){
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
							this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
						}
						this.emailContentMarkdownForEdit = this.recommendedAction.text as string
					}
				}

				this.emailDialog = true
			}catch (error) {
				console.error(error);
			}
			this.overlay = false
		},
		async sendEmail(){
			this.overlay = true
			this.emailDialog = false

			const emailSendInput: EmailSendInput = {
				productTrackId: this.trackDto?.id ? this.trackDto.id : '0',
				userEmail: this.user.userDto?.email,
				to: this.userSavedContactDetail.unit?.email,
				userSavedContactId: this.userSavedContactDetail.id,
				subject: this.recommendedAction?.title,
				content: this.emailContentMarkdownForEdit,
			}

			let sendEmailResp
			try {
				sendEmailResp = await this.api$.businessMatchApi.sendEmail(this.user.userDto?.id as string, emailSendInput)

				this.emailSuccessDialog = true
			}catch (error) {
				console.error(error);
			}
			this.overlay = false
		},
		linkifyText(text: string): string {
			const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			return escaped.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" class="primary--text font-weight-medium" style="word-break: break-all;">$1</a>')
		},
		// 發送信件相關方法
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		async openSendEmailDialog(contact: any) {
			// 先關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			this.overlay = true
			try {
				// 先建立 sharing user 取得分享連結
				const userId = this.user.userDto?.id as string
				const response = await this.api$.sharingUserApi.createSharingUser(userId)
				const sharingId = response.data.data?.id

				// 若不是 localhost，在 // 和 ws 之間加入 trackDto.name.
				let baseUrl = process.env.VUE_APP_BASE_URL as string
				if (!baseUrl.includes('localhost') && this.trackDto?.name && this.trackDto?.id !== '0') {
					baseUrl = baseUrl.replace('//ws', `//${this.trackDto.name}.ws`)
				}
				this.sendEmailSharingUrl = `${baseUrl}/nl-match/profile-sharing/${sharingId}`
				this.sendEmailFixedContent = `[View Business Card →]: ${this.sendEmailSharingUrl}`

				this.sendEmailDialog = true
			} catch (error) {
				console.error('Failed to create sharing user:', error)
			} finally {
				this.overlay = false
			}
		},
		closeSendEmailDialog() {
			this.sendEmailDialog = false
		},
		async sendEmailToUnit() {
			if (!this.sendEmailSubject.trim() || !this.sendEmailContent.trim()) return

			// 先關閉 dialog
			this.closeSendEmailDialog()
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			this.overlay = true
			try {
				const fullContent = `${this.sendEmailContent}\n\n${this.sendEmailFixedContent}`

				const requestBody = {
					userId: this.user.userDto?.id as string,
					unitId: this.userSavedContactDetail.unitId,
					productTrackId: this.trackDto?.id,
					subject: this.sendEmailSubject,
					content: fullContent,
					userSavedContactId: this.userSavedContactDetail.id
				}

				await this.api$.emailApi.sendEmailToUnit(requestBody)

				// 清空主旨和信件內容
				this.sendEmailSubject = ''
				this.sendEmailContent = ''
				this.sendEmailFixedContent = ''

				// 顯示成功訊息
				this.snackbarColor = '#1976D1'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessAddedTo'))
				this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessMyContacts'))
				this.snackbarLinkRoute = '/match/my-contacts'
				this.snackbarTextAfter = String(this.$t('businessMatchResults.detailDrawer.connectSuccessNotifiedByEmail'))
				this.snackbar = true
			} catch (error) {
				console.error('Failed to send email:', error)
				// 顯示失敗訊息
				this.snackbarColor = 'error'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.emailSendFailed'))
				this.snackbarLinkText = ''
				this.snackbarTextAfter = ''
				this.snackbar = true
			} finally {
				this.overlay = false
			}
		},
		async addUnitAsFriend(unitId: number) {
			const userId = this.user.userDto?.id as string
			if (!userId || !unitId) return null

			try {
				const response = await this.api$.userFriendApi.addUnitAsFriend(userId, unitId)
				return response.data.data
			} catch (error) {
				console.error('Failed to add unit as friend:', error)
				return null
			}
		},
		async sendTemplateEmail(input: SendMarkdownEmailInput) {
			try {
				await this.api$.emailApi.sendEmail1(input)
			} catch (error) {
				console.error('Failed to send email:', error)
			}
		},
		async handleConnect(contact: UserSavedContactDetail) {
			const unitId = contact.unit?.id
			const productTrackId = contact.unit?.productTrackId

			if (!unitId) return

			// 檢查使用者個人資料是否完整
			if (!this.userDto?.companyTitle || !this.userDto?.email || !this.userDto?.companyName) {
				this.snackbarColor = 'warning'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.incompleteProfile'))
				this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.goToProfile'))
				this.snackbarLinkRoute = '/profile'
				this.snackbarTextAfter = ''
				this.snackbar = true
				return
			}

			this.overlay = true

			// 關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			try {
				if (productTrackId === '0') {
					const toEmail = contact.unit?.email

					// 同時呼叫 addUnitAsFriend
					const promises: Promise<any>[] = [
						this.addUnitAsFriend(unitId)
					]
					await Promise.all(promises)

					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const userName = `${contact.unit?.firstName || ''} ${contact.unit?.lastName || ''}`.trim()

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.connectUser.subject'))
						let content = String(this.$t('emailTemplates.connectUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						content = content
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)

						// 條件式行：Title
						if (senderTitle) {
							content = content.replace(/\{sender_title\}/g, senderTitle)
						} else {
							content = content.replace(/\n- Title: \{sender_title\}/g, '')
						}

						// 條件式行：Looking for
						if (senderLookingFor) {
							content = content.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							content = content.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式行：Offers
						if (senderOffers) {
							content = content.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							content = content.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// [Login to Accept →] 後面加入 NonLoginChatRoom 連結
						content = content.replace('[Login to Accept →]', `[Login to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content
						})
					}

					// 顯示成功訊息
					this.snackbarColor = '#1976D1'
					this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessConnected'))
					this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessStartConversation'))
					this.snackbarLinkRoute = '/chat'
					this.snackbarTextAfter = ''
					this.snackbar = true
				} else {
					const toEmail = contact.unit?.email

					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const trackId = this.trackDto?.id ?? ''
						let userName = ''
						if (['4', '7'].includes(trackId)) {
							userName = contact.unit?.entityName || ''
						} else {
							userName = `${contact.unit?.firstName || ''} ${contact.unit?.lastName || ''}`.trim()
						}

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderIndustry = userDto?.companyIndustry?.join(', ') || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''
						const senderMatchReasonItems = contact.summaries?.filter(Boolean) || []
						const senderMatchReason = senderMatchReasonItems.length > 0 ? '\n  - ' + senderMatchReasonItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.connectNonUser.subject'))
						let content = String(this.$t('emailTemplates.connectNonUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						content = content
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)
							.replace(/\{sender_industry\}/g, senderIndustry)

						// 條件式行：Title（在 greeting 行中）
						if (senderTitle) {
							content = content.replace(/\{sender_title\}/g, senderTitle)
						} else {
							content = content.replace(/, \{sender_title\}/g, '')
						}

						// 條件式行：Looking for
						if (senderLookingFor) {
							content = content.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							content = content.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式行：Offers
						if (senderOffers) {
							content = content.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							content = content.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// Why they want to connect
						if (senderMatchReason) {
							content = content.replace(/\{sender_match_reason\}/g, senderMatchReason)
						} else {
							content = content.replace(/\n- Why they want to connect: \{sender_match_reason\}/g, '')
						}

						// [Register to Accept →] 後面加入 NonLoginChatRoom 連結
						content = content.replace('[Register to Accept →]', `[Register to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content
						})
					}

					// 顯示成功訊息
					this.snackbarColor = '#1976D1'
					this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessMyContacts'))
					this.snackbarLinkRoute = '/match/my-contacts'
					if (toEmail) {
						this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessAddedTo'))
						this.snackbarTextAfter = String(this.$t('businessMatchResults.detailDrawer.connectSuccessNotifiedByEmail'))
					} else {
						this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessConnectedAddedTo'))
						this.snackbarTextAfter = ''
					}
					this.snackbar = true
				}
			} finally {
				this.overlay = false
			}
		},
		async handleMessage(contact: UserSavedContactDetail) {
			const unitId = contact.unit?.id
			const productTrackId = contact.unit?.productTrackId

			if (!unitId) return

			this.overlay = true

			// 關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			try {
				if (productTrackId === '0') {
					const toEmail = contact.unit?.email

					// 同時呼叫 addUnitAsFriend
					const promises: Promise<any>[] = [
						this.addUnitAsFriend(unitId)
					]
					const [friendResponse] = await Promise.all(promises)

					// 寄送 messageUser 模板信件
					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const userName = `${contact.unit?.firstName || ''} ${contact.unit?.lastName || ''}`.trim()

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.messageUser.subject'))
						let emailContent = String(this.$t('emailTemplates.messageUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						emailContent = emailContent
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)

						// 條件式：Title
						if (senderTitle) {
							emailContent = emailContent.replace(/\{sender_title\}/g, senderTitle)
						} else {
							emailContent = emailContent.replace(/\n- Title: \{sender_title\}/g, '')
						}

						// 條件式：Looking for
						if (senderLookingFor) {
							emailContent = emailContent.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							emailContent = emailContent.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式：Offers
						if (senderOffers) {
							emailContent = emailContent.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							emailContent = emailContent.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// 替換連結（使用 NonLoginChatRoom URL）
						emailContent = emailContent.replace('[Login to Accept →]', `[Login to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content: emailContent
						})
					}

					// 跳轉到 chat
					if (friendResponse?.friendUserId) {
						localStorage.setItem('TARGET_USER_ID', friendResponse.friendUserId)
						this.$router.push('/chat')
					}
				} else {
					const toEmail = contact.unit?.email

					if (toEmail) {
						// 建立 sharingUser
						const userId = this.user.userDto?.id as string
						const response = await this.api$.sharingUserApi.createSharingUser(userId)
						const sharingId = response.data.data?.id
						let baseUrl = process.env.VUE_APP_BASE_URL as string
						if (!baseUrl.includes('localhost') && this.trackDto?.name && this.trackDto?.id !== '0') {
							baseUrl = baseUrl.replace('//ws', `//${this.trackDto.name}.ws`)
						}
						const sharingUrl = `${baseUrl}/nl-match/profile-sharing/${sharingId}`

						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const trackId = this.trackDto?.id ?? ''
						let userName = ''
						if (['4', '7'].includes(trackId)) {
							userName = contact.unit?.entityName || ''
						} else {
							userName = `${contact.unit?.firstName || ''} ${contact.unit?.lastName || ''}`.trim()
						}

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.messageNonUser.subject'))
						let templateContent = String(this.$t('emailTemplates.messageNonUser.content'))
						let fixedContent = String(this.$t('emailTemplates.messageNonUser.fixedContent'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						templateContent = templateContent
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_title\}/g, senderTitle)
							.replace(/\{sender_company\}/g, senderCompany)

						// 替換連結
						templateContent = templateContent.replace('[View Business Card →]', `[View Business Card →]: ${sharingUrl}`)
						fixedContent = fixedContent.replace('[Register to Message →]', `[Register to Message →]: ${nonLoginChatUrl}`)

						// 帶入主旨、內文、固定區塊
						this.sendEmailSubject = subject
						this.sendEmailContent = templateContent
						this.sendEmailFixedContent = fixedContent
						this.sendEmailSharingUrl = sharingUrl

						// 打開 dialog
						this.sendEmailDialog = true
					}
				}
			} finally {
				this.overlay = false
			}
		},
		async deleteSavedContact(id: string | undefined){
			this.deleteDialog = false
			this.overlay = true
			try{
				await this.api$.savedContactApi._delete(this.user.userDto?.id as string, id as string)
				// 直接從列表中移除對應項目
				const targetContact = this.savedContacts.userSavedContactDetails?.find(contact => contact.id === id)
				if (targetContact) {
					const index = this.savedContacts.userSavedContactDetails?.indexOf(targetContact)
					if (index !== undefined && index > -1) {
						this.savedContacts.userSavedContactDetails?.splice(index, 1)
					}
				}
				// 如果 detailDrawer 開啟且是同一個項目，關閉 drawer
				if (this.userSavedContactDetail && this.userSavedContactDetail.id === id) {
					this.detailDrawer = false
					this.mobileDetailDrawer = false
					this.userSavedContactDetail = {} as UserSavedContactDetail
				}
			}catch (error) {
				console.error('Error deleting saved contact:', error);
			}
			this.overlay = false
		},
		async downloadCSV(){
			const trackId = this.trackDto?.id || ''
			const userId = this.user.userDto?.id;
			try {
				const downloadUrl = process.env.VUE_APP_API_BASE_URL+`/api/user/${userId}/business-match/download-match-results?productTrackId=${trackId}`;
				window.open(downloadUrl, '_blank');
			} catch (error) {
				console.error('Error downloading CSV:', error);
			}
		},
		onSearchStarted() {
			this.isSearchLoading = true
			this.progressValue = 0
			this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))

			// 啟動進度條動畫 - 15秒分成4等份
			let startTime = Date.now()

			this.progressInterval = setInterval(() => {
				const elapsed = Date.now() - startTime
				const timer = elapsed / 1000 // 轉換為秒

				if (timer >= 15) {
					// 超過15秒，保持在99%
					this.progressValue = 99
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					return
				}

				if (timer <= 3.75) {
					// 第一等分：分析您的需求
					this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))
					this.progressValue = (timer / 3.75) * 24.75  // 0-24.75%
				} else if (timer > 3.75 && timer <= 7.5) {
					// 第二等分：搜尋相關成員
					this.progressStatusText = String(this.$t('common.progressStatus.searchingMembers'))
					this.progressValue = 24.75 + ((timer - 3.75) / 3.75) * 24.75  // 24.75-49.5%
				} else if (timer > 7.5 && timer <= 11.25) {
					// 第三等分：智慧配對中
					this.progressStatusText = String(this.$t('common.progressStatus.smartMatching'))
					this.progressValue = 49.5 + ((timer - 7.5) / 3.75) * 24.75  // 49.5-74.25%
				} else if (timer > 11.25 && timer <= 15) {
					// 第四等分：生成結果
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					this.progressValue = 74.25 + ((timer - 11.25) / 3.75) * 24.75  // 74.25-99%
				}
			}, 100)  // 每100ms更新一次，讓動畫更平滑
		},
		onSearchFinished() {
			// 完成動畫 - 與 UserProfile.vue 相同的邏輯
			this.progressValue = 100
			clearInterval(this.progressInterval)
			setTimeout(() => {
				this.isSearchLoading = false
				this.progressValue = 0
				this.progressStatusText = ''
			}, 500)
		}
	},
	async created(){
		this.overlay = true
		await this.getMe()
		await this.getUserSavedContacts()
		this.overlay = false
	},
	watch: {
		'$i18n.locale': {
			immediate: false,
			async handler() {
				this.overlay = true
				if (this.savedContacts.userSavedContactDetails && this.savedContacts.userSavedContactDetails.length > 0) {
					if (i18n.locale === 'zh') {
						await translateMatches(this.savedContacts.userSavedContactDetails, 'zh-Hant')
					} else if (i18n.locale === 'en') {
						await translateMatches(this.savedContacts.userSavedContactDetails, 'en-US')
					} else if (i18n.locale === 'ja') {
						await translateMatches(this.savedContacts.userSavedContactDetails, 'ja')
					}
				}
				this.overlay = false
			}
		}
	},
	mounted() {
		// 監聽搜尋事件
		this.eventHub$.$on('searchStarted', this.onSearchStarted)
		this.eventHub$.$on('searchFinished', this.onSearchFinished)
	},
	beforeDestroy() {
		// 移除 eventHub 監聽器
		this.eventHub$.$off('searchStarted', this.onSearchStarted)
		this.eventHub$.$off('searchFinished', this.onSearchFinished)
	}
});
